<script setup>
import { useI18n } from 'vue-i18n';
import Avatar from 'dashboard/components-next/avatar/Avatar.vue';

defineProps({
  cluster: {
    type: Object,
    required: true,
  },
});

defineEmits(['select']);

const { t } = useI18n();
</script>

<template>
  <div
    class="flex items-center gap-3 px-6 py-2.5 transition-colors cursor-pointer group hover:bg-n-alpha-1"
    role="button"
    tabindex="0"
    @click="$emit('select', cluster)"
    @keyup.enter="$emit('select', cluster)"
  >
    <Avatar :name="cluster.name" :size="36" />

    <!-- Identity -->
    <div class="flex flex-col min-w-0">
      <span class="text-sm font-medium truncate text-n-slate-12">
        {{ cluster.name }}
      </span>
      <span
        v-if="cluster.cluster_type?.label_singular"
        class="text-xs truncate text-n-slate-10"
      >
        {{ cluster.cluster_type.label_singular }}
      </span>
    </div>

    <!-- Members count pill -->
    <span
      class="flex items-center gap-1 px-2 py-0.5 ml-auto text-xs rounded-md shrink-0 sm:ml-0 bg-n-alpha-1 text-n-slate-11"
      :title="t('CLUSTERS.FIELDS.MEMBERS_COUNT')"
    >
      <span class="i-lucide-users size-3.5" />
      {{ cluster.members_count || 0 }}
    </span>

    <!-- Affordance -->
    <span
      class="i-lucide-chevron-right size-4 shrink-0 text-n-slate-8 transition-colors group-hover:text-n-slate-10"
    />
  </div>
</template>
